import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console and potentially send to error tracking service
    console.error('Error Boundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0D0D0D',
          padding: '20px'
        }}>
          <div style={{
            maxWidth: '600px',
            background: '#1A1A1A',
            border: '1px solid rgba(255, 107, 107, 0.3)',
            borderRadius: '12px',
            padding: '40px',
            textAlign: 'center'
          }}>
            <div style={{
              width: '64px',
              height: '64px',
              margin: '0 auto 24px',
              background: 'rgba(255, 107, 107, 0.1)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '32px'
            }}>
              ⚠️
            </div>
            
            <h1 style={{
              fontSize: '24px',
              fontWeight: '600',
              color: '#FF6B6B',
              marginBottom: '12px',
              fontFamily: 'Space Grotesk, sans-serif'
            }}>
              Something went wrong
            </h1>
            
            <p style={{
              fontSize: '16px',
              color: '#EAEAEA',
              marginBottom: '24px',
              lineHeight: '1.5'
            }}>
              We encountered an unexpected error. Please try refreshing the page or contact support if the problem persists.
            </p>

            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details style={{
                marginBottom: '24px',
                textAlign: 'left',
                background: 'rgba(255, 107, 107, 0.05)',
                padding: '16px',
                borderRadius: '8px',
                fontSize: '12px',
                color: '#EAEAEA'
              }}>
                <summary style={{ cursor: 'pointer', fontWeight: '600', marginBottom: '8px' }}>
                  Error Details (Dev Only)
                </summary>
                <p style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', marginTop: '8px' }}>
                  {this.state.error.toString()}
                </p>
                {this.state.errorInfo && (
                  <p style={{ fontFamily: 'monospace', whiteSpace: 'pre-wrap', fontSize: '11px', marginTop: '8px' }}>
                    {this.state.errorInfo.componentStack}
                  </p>
                )}
              </details>
            )}
            
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '12px 32px',
                background: '#4B9DFF',
                color: '#FFF',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(75, 157, 255, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
